import {
  UseQueryResult,
  useQuery,
} from "@tanstack/react-query";
import { queries } from "../services/queries";
import Billing from "../services/Billing";

export function useBillingOverviewCards(): UseQueryResult<any> {
  return useQuery({
    ...queries.billing.getOverviewCards,
    queryFn: () => Billing.getOverviewCards(),
    refetchOnWindowFocus: false,
  });
}

export function useBillingCompaniesList(
  pageNumber?: number,
  pageSize?: number,
  searchText?: string,
  statusFilter?: string
): UseQueryResult<any> {
  return useQuery({
    ...queries.billing.getCompaniesList(pageNumber, pageSize, searchText, statusFilter),
    refetchOnWindowFocus: false,
  });
}

export function useBillingChart(month?: string, companyId?: number): UseQueryResult<any> {
  return useQuery({
    ...queries.billing.getChart(month, companyId),
    queryFn: async () => {
      const result = await Billing.getChart(month, companyId);
      return result;
    },
    refetchOnWindowFocus: false,
    staleTime: 0, // Always consider data stale to refetch on month/company change
  });
}

export function useBillingSubscriptionData(
  companyId?: number,
  month?: string,
  pageSize?: number,
  pageNumber?: number
): UseQueryResult<any> {
  return useQuery({
    ...queries.billing.getSubscriptionData(companyId, month, pageSize, pageNumber),
    queryFn: () =>
      Billing.getSubscriptionData(companyId, month, pageSize, pageNumber),
    refetchOnWindowFocus: false,
    enabled: !!month, // Only fetch when month is provided
  });
}

export function useBillingCompanyInvoices(
  companyId?: number,
  month?: string,
  year?: string,
  pageSize?: number,
  pageNumber?: number
): UseQueryResult<any> {
  return useQuery({
    ...queries.billing.getCompanyInvoices(companyId, month, year, pageSize, pageNumber),
    queryFn: () =>
      Billing.getCompanyInvoices(companyId, month, year, pageSize, pageNumber),
    refetchOnWindowFocus: false,
    enabled: !!companyId, // Only fetch when companyId is provided
  });
}

